import { CheckCircleTwoTone } from '@ant-design/icons';
import { Row } from 'antd';

import { ISnapStore } from 'containers/Snaps/Snap/store';
import { MilesText } from 'components';

import { ICommonStore } from 'stores';
import { getConfidenceColor } from 'utils';

import { TFieldProps } from 'types';

export const fields = ({
  retailers,
  ocrScores,
  isEditDisabled,
  hasFlippedDayAndYear,
  enabledBaseIssuanceRetailer,
}: {
  retailers: ICommonStore['retailers'],
  ocrScores: ISnapStore['ocrScores'],
  isEditDisabled: boolean,
  hasFlippedDayAndYear?: boolean,
  enabledBaseIssuanceRetailer?: boolean,
}): TFieldProps[] => {
  const getBackground = getConfidenceColor(ocrScores);

  return [{
    type: TFieldProps.type.Select,
    name: 'retailerId',
    label: 'Retailer',
    options: retailers,
    disabled: isEditDisabled,
    extra: (
      enabledBaseIssuanceRetailer && (
        <Row className='pt-1'>
          <CheckCircleTwoTone className='text-[18px] mr-1' />

          <MilesText>
            Retailer is a partner
          </MilesText>
        </Row>
      )
    ),
    rules: [{
      required: true,
      message: 'Retailer is required!',
    }],
  }, {
    type: TFieldProps.type.DatePicker,
    name: 'receiptTimestamp',
    label: 'Receipt Date',
    showTime: true,
    extra: 'Shown in collector’s timezone',
    tooltip: hasFlippedDayAndYear ? 'Has flipped day and year' : '',
    disabled: isEditDisabled,
    inputStyles: { backgroundColor: getBackground('receiptTimestamp') },
    rules: [{
      required: true,
      message: 'Receipt Date is required!',
    }],
  }, {
    type: TFieldProps.type.Currency,
    name: 'subtotal',
    label: 'Subtotal',
    inputStyles: { backgroundColor: getBackground('subtotal') },
    rules: [{
      type: 'number',
      min: 0.01,
      required: true,
      message: 'Subtotal should be minimum 0.01!',
    }],
  }, {
    type: TFieldProps.type.Currency,
    name: 'totalTax',
    label: 'Total Tax',
    inputStyles: { backgroundColor: getBackground('totalTax') },
  }, {
    type: TFieldProps.type.Currency,
    name: 'total',
    label: 'Total',
    inputStyles: { backgroundColor: getBackground('total') },
    rules: [{
      type: 'number',
      min: 0.01,
      required: true,
      message: 'Total should be minimum 0.01!',
    }],
  }];
};
